import { NewConversationResponse } from './newConvesationSignature.interface';

import collectiveApi from 'modules/common/collectiveApi';

const startNewConversation = async (params: {
    id: string;
    metadata: Record<string, any>;
}): Promise<NewConversationResponse> => {
    const response = await collectiveApi.post<NewConversationResponse>(`/ai/member/conversations`, params);
    return response.data;
};

export default startNewConversation;
